import { useContext, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { UserContext } from '../../App';
import { ComponentContext } from '../../ContextWrappers/NRComponentContextWrapper';
import { GET_RESOURCE_PERMISSIONS } from '../../graphql/queries/rbac';
import { handleGraphQLError } from '../../graphql/utils';
import { ACR_RESOURCE_TYPE } from '../../pages/NRSettings/NRUsersAndAccess/rbac.constants';
import { resolveEffectiveResourceScope } from './useResourcePermissions.utils';

const EMPTY_PERMISSIONS = [];

export { resolveEffectiveResourceScope };

function useResourcePermissions({ resourceType = ACR_RESOURCE_TYPE.ORGANIZATION, resourceId, skip = false } = {}) {
  const { currentOrgId } = useContext(UserContext);
  const { enqueueSnackbar } = useSnackbar();
  const { componentId } = useParams();
  const { asset } = useContext(ComponentContext);

  const { resourceType: effectiveResourceType, resourceId: effectiveResourceId } = resolveEffectiveResourceScope({
    resourceType,
    resourceId,
    currentOrgId,
    assetId: asset?.id,
    componentId
  });

  const shouldSkip = skip || !effectiveResourceId;

  const { data, loading, error } = useQuery(GET_RESOURCE_PERMISSIONS, {
    skip: shouldSkip,
    fetchPolicy: 'cache-first',
    variables: {
      resourceType: effectiveResourceType,
      resourceId: effectiveResourceId
    },
    errorPolicy: 'all'
  });

  useEffect(() => {
    if (error) {
      handleGraphQLError({ error, enqueueSnackbar });
    }
  }, [error, enqueueSnackbar]);

  return {
    permissions: shouldSkip ? EMPTY_PERMISSIONS : data?.getResourcePermissions?.permissions ?? EMPTY_PERMISSIONS,
    loading: shouldSkip ? false : loading,
    error
  };
}

export default useResourcePermissions;
